import "./App.css";
import store from "../../app/store";
import { Provider } from "react-redux";

/**
 * Acts as a common entry point for each of our applications (contributions, profilePage)
 * The desired page gets passed as props.children
 * @param {{}} props
 * @returns
 */
function App(props) {
  return (
    <div className="container content">
      <Provider store={store}>{props.children}</Provider>
    </div>
  );
}

export default App;
